import React, { useCallback, useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { api } from "../../lib/api";
import { BTN, INPUT, errMsg } from "../../components/crm/crmUtil";

const EMPTY = { kind: "labor", code: "", name: "", unit: "hr", unit_cost: "", effective_from: "" };

// B5 part 2a: company rate library (tenant data, effective-dated; a new rate closes the previous one for that code).
export default function RateLibrary() {
  const [rows, setRows] = useState(null);
  const [f, setF] = useState(EMPTY);
  const [msg, setMsg] = useState({ ok: "", err: "" });
  const load = useCallback(() => api.get("/estimating/rates").then((r) => setRows(r.data)).catch((e) => setMsg({ ok: "", err: errMsg(e) })), []);
  useEffect(() => { load(); }, [load]);
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/estimating/rates", { ...f, unit_cost: Number(f.unit_cost) }); setF({ ...EMPTY, kind: f.kind }); setMsg({ ok: "Rate added. Existing estimates keep the rate they used.", err: "" }); load(); }
    catch (x) { setMsg({ ok: "", err: errMsg(x) }); }
  };
  const field = (k, label, type = "text") => <label htmlFor={`rate-${k}`} className="text-sm">{label}<input id={`rate-${k}`} type={type} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={INPUT} data-testid={`rate-${k}`} /></label>;
  return (
    <AppShell title="Company rate library" subtitle="Your own labor, equipment and material rates — never market prices">
      <div className="mx-auto w-full max-w-[1000px] px-4 md:px-6 space-y-4" data-testid="rate-library">
        <form onSubmit={add} className="border border-erf-borderCream rounded bg-white p-4 grid grid-cols-2 gap-2 md:grid-cols-7 md:items-end">
          <label htmlFor="rate-kind" className="text-sm">Kind<select id="rate-kind" value={f.kind} onChange={(e) => setF({ ...f, kind: e.target.value })} className={INPUT} data-testid="rate-kind">{["labor", "equipment", "material"].map((k) => <option key={k} value={k}>{k}</option>)}</select></label>
          {field("code", "Code")}{field("name", "Name")}{field("unit", "Unit")}{field("unit_cost", "Unit cost", "number")}{field("effective_from", "Effective from", "date")}
          <button type="submit" disabled={!f.code || !f.name || !f.effective_from || f.unit_cost === ""} className={`${BTN} bg-erf-dark text-white col-span-2 md:col-span-1`} data-testid="rate-add">Add rate</button>
        </form>
        {msg.err && <p role="alert" className="text-sm text-red-700" data-testid="rate-error">{msg.err}</p>}
        {msg.ok && <p role="status" className="text-sm text-green-800" data-testid="rate-saved">{msg.ok}</p>}
        {rows?.length === 0 && <p className="text-sm" data-testid="rate-empty">No rates yet. Add your company's own rates above.</p>}
        <ul className="space-y-2">{(rows || []).map((r) => (
          <li key={r.id} className={`border border-erf-borderCream rounded bg-white p-3 text-sm ${r.effective_to ? "text-erf-dark/50" : ""}`} data-testid={`rate-row-${r.id}`}>
            <strong>{r.code}</strong> · {r.name} · {r.kind} · ${r.unit_cost}/{r.unit} · from {r.effective_from}{r.effective_to ? ` to ${r.effective_to}` : " (current)"}
          </li>
        ))}</ul>
      </div>
    </AppShell>
  );
}
